// extracted by mini-css-extract-plugin
export default {"wrapper":"Navbar_wrapper__vd9XE","nav":"Navbar_nav__wG5QH"};